import { AnchorHTMLAttributes, forwardRef, FC, ReactNode, PropsWithChildren } from 'react';

import reactToText from 'react-to-text';

import { overlayLinkStyle } from './LinkOverlay.css';
import { getClassNames } from '../../util/css';
import { overlayButtonStyle, overlayBoxStyle } from '../ButtonOverlay/ButtonOverlay.css';

type CompoundLinkOverlay = {
  Link: typeof Link;
};

type LinkProps = Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'download' | 'href' | 'hrefLang' | 'rel' | 'target'> & {
  /**
   * TODO: Custom type children to ReactNode or JSX.Element when we support
   * `asChild` prop.
   */
  children: ReactNode;
};

const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ children, ...anchorAttributes }, ref) => {
  const classNames = getClassNames(overlayLinkStyle, overlayButtonStyle);
  return (
    <a {...anchorAttributes} className={classNames} data-label={reactToText(children)} ref={ref}>
      {children}
    </a>
  );
});

/**
 * For more information on this component and how it works, refer to the ButtonOverlay component.
 */
export const LinkOverlay: FC<PropsWithChildren<{ className?: string }>> & CompoundLinkOverlay = ({
  className = '',
  children,
}) => {
  const classNames = getClassNames(overlayBoxStyle, className);
  return <div className={classNames}>{children}</div>;
};

LinkOverlay.Link = Link;
LinkOverlay.displayName = 'LinkOverlay';
